module.exports = __webpack_public_path__ + "72fc0fb7d5f4b679e4112108739277db.mp4";